import { getSingle, getDocs } from "shared/prismic";
import { PeopleOverviewPage } from "containers/PeopleOverviewPage";

export async function getStaticProps({ preview = null, previewData }) {
  const doc = await getSingle({ previewData, type: "team_overview" });
  const people = await getDocs({ previewData, type: "team_detail" });
  const filters = {};

  return { props: { doc, people, preview, filters } };
}

export default PeopleOverviewPage;
